import type {Group, Texture, Color, Vector2} from 'three'

export const path = '/images/modules/site/home24/webgl-assets'

export interface Gltf {
  src: string
  scene?: null | Group
}

export interface Image {
  src: string
  texture?: null | Texture
  flipY: boolean
}

export interface TextureData {
  ao: string
  color: string | null
  colorVec: Color
  matcap: string
  noiseRange: Vector2
  fogRangeZ: Vector2
}
